var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 55,
    viewBox: "0 0 40 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0007 26.0125C18.0007 30.4305 14.4182 34.0165 10.0001 34.0165C5.583 34.0165 2.00049 30.4305 2.00049 26.0125C2.00049 21.5905 5.583 18.0085 10.0001 18.0085C14.4182 18.0085 18.0007 21.5905 18.0007 26.0125Z",
    stroke: "#303634",
    strokeWidth: 4.00086,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0008 46.5195C32.0008 49.5585 29.5358 52.0235 26.5001 52.0235C23.4654 52.0235 21.0005 49.5585 21.0005 46.5195C21.0005 43.4805 23.4654 41.0165 26.5001 41.0165C29.5358 41.0165 32.0008 43.4805 32.0008 46.5195Z",
    stroke: "#303634",
    strokeWidth: 4.00086,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0002 7.50444C38.0002 10.5434 35.5363 13.0044 32.5006 13.0044C29.4659 13.0044 27.001 10.5434 27.001 7.50444C27.001 4.46544 29.4659 2.00043 32.5006 2.00043C35.5363 2.00043 38.0002 4.46544 38.0002 7.50444Z",
    stroke: "#303634",
    strokeWidth: 4.00086,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3604 20.7584L28.4141 11.2664",
    stroke: "#303634",
    strokeWidth: 4.00086,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4884 41.8555L15.6448 31.8835",
    stroke: "#303634",
    strokeWidth: 4.00086,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.718197f4922f1be4b427b20bb83a3367.svg";
export { ForwardRef as ReactComponent };